import * as React from "react";
import Shell from "../layout/shell";
import { isHeroSlice, isCardLayout } from "../helpers/prismicHelpers";
import { Hero } from "../components/hero";
import { Cards } from "../components/cards";
import { FullCaseStudy } from "../components/fullCaseStudy";
import "./our-approach.scss";

var OurApproach = function OurApproach(_ref) {
  var data = _ref.data;

  var _React$useState = React.useState(0),
      selectedCaseStudyIndex = _React$useState[0],
      setSelectedCaseStudyIndex = _React$useState[1];

  var content = data.prismic.allOur_approachs.edges[0].node;
  var caseStudySlices = content.body.filter(function (slice) {
    return slice.type === "full_case_study";
  });
  return /*#__PURE__*/React.createElement(Shell, null, content.body.map(function (slice, index) {
    if (isHeroSlice(slice)) {
      return /*#__PURE__*/React.createElement(Hero, {
        className: "hero-alt" + (index === 0 ? '' : ' minor-hero'),
        data: slice
      });
    }

    if (isCardLayout(slice)) {
      return /*#__PURE__*/React.createElement(Cards, {
        data: slice
      });
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "case-study-tabs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed-width"
  }, caseStudySlices.map(function (slice, index) {
    return /*#__PURE__*/React.createElement("div", {
      "data-selected": index === selectedCaseStudyIndex,
      onClick: function onClick() {
        return setSelectedCaseStudyIndex(index);
      }
    }, slice.primary.tab_title);
  }))), /*#__PURE__*/React.createElement(FullCaseStudy, {
    data: caseStudySlices[selectedCaseStudyIndex]
  }));
};

export default OurApproach;
export var query = "3729273566";